import { render, staticRenderFns } from "./SalesBasisInfo.vue?vue&type=template&id=4d35e069&scoped=true"
import script from "./SalesBasisInfo.vue?vue&type=script&lang=js"
export * from "./SalesBasisInfo.vue?vue&type=script&lang=js"
import style0 from "./SalesBasisInfo.vue?vue&type=style&index=0&id=4d35e069&prod&scoped=true&lang=css"
import style1 from "./SalesBasisInfo.vue?vue&type=style&index=1&id=4d35e069&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d35e069",
  null
  
)

export default component.exports